module.exports = "/static/images/boat.jpg";